import React from "react";
import ForgotPasswordForm from "../auth/components/ForgotPasswordForm";

const ForgotPasswordPage = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPasswordPage;
